

// import './CollectionItem.css';
import { collectionitems } from '../../data/collectionitems';
import ItemCard from '../../components/ItemCard/ItemCard';

const CollectionItem = () => {

    const showAllDescription = () => {
        document.querySelector('.collection_description').classList.add('show');
        document.querySelector('.collection_downarrow').classList.add('hidden');
        document.querySelector('.collection_uparrow').classList.remove('hidden');
    }
    const hideAllDescription = () => {
        document.querySelector('.collection_description').classList.remove('show');
        document.querySelector('.collection_downarrow').classList.remove('hidden');
        document.querySelector('.collection_uparrow').classList.add('hidden');
    }

    return(
        <div>

            <div className="h-[25vh] collection_item_container" 
                style={{background: "url('https://images.unsplash.com/photo-1586672806791-3a67d24186c0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80')",
                        backgroundSize: 'cover'}}>
            </div>

            <div className="max-w-[1500px] mx-auto px-[5vw] lg:px-20">

                <div className="flex justify-center w-full">
                    <div className="w-full max-w-[70px] sm:max-w-[100px] lg:max-w-[150px] 2xl:max-w-[200px] relative -top-[35px] md:-top-[50px] lg:-top-[75px] 2xl:-top-[100px] -mb-[35px] md:-mb-[50px] lg:-mb-[75px] 2xl:-mb-[100px]">
                        <img src = 'https://images.unsplash.com/photo-1610216705422-caa3fcb6d158?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80' 
                            alt = 'collectionimage' className = 'w-full h-full object-cover rounded-full'/>
                    </div>
                </div>
                <div className='flex flex-col items-center w-full mt-4'>
                    
                    <h1 className='text-center font-bold text-xl sm:text-2xl lg:text-3xl max-w-[27ch] mb-4'>Amoled</h1>
                    <p className='collection_description text-center text-sm sm:text-base text-gray-400 max-w-[800px] max-h-[59px] overflow-hidden'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                    <button onClick={showAllDescription} className = 'collection_downarrow'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' className='w-[16px]' viewBox="0 0 320 512">
                           <path d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"/>
                        </svg>
                    </button>
                    <button onClick={hideAllDescription} className = 'collection_uparrow hidden'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' className='w-[16px]' viewBox="0 0 320 512">
                            <path d="M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"/>
                        </svg>
                    </button>
                    <div className='grid grid-cols-2 md:grid-cols-4 mt-5'>

                        <div className='flex flex-col justify-center items-center p-3 m-3 shadow-shadow3 bg_gradient rounded-[8px]'>
                            <p className='text-center sm:text-lg lg:text-xl max-w-[30ch] font-bold'>55K</p>
                            <p className='text-center text-gray-300 text-base sm:text-lg lg:text-xl max-w-[30ch]'>Items</p>
                        </div>
                        <div className='flex flex-col justify-center items-center p-3 m-3 shadow-shadow3 bg_gradient rounded-[8px]'>
                            <p className='text-center text-base sm:text-lg lg:text-xl max-w-[30ch] font-bold'>55K</p>
                            <p className='text-center text-gray-300 text-base sm:text-lg lg:text-xl max-w-[30ch]'>Owners</p>
                        </div>
                        <div className='flex flex-col justify-center items-center p-3 m-3 shadow-shadow3 bg_gradient rounded-[8px]'>
                            <div className='flex '>                             
                                <p className='text-center text-base sm:text-lg lg:text-xl max-w-[30ch] font-bold'>66</p>
                            </div>
                            <p className='text-center text-gray-300 text-base sm:text-lg lg:text-xl max-w-[30ch]'>Floor Price</p>
                        </div>
                        <div className='flex flex-col justify-center items-center p-3 m-3 shadow-shadow3 bg_gradient rounded-[8px]'>
                            <div className='flex'>
                                <p className='text-center text-base sm:text-lg lg:text-xl max-w-[30ch] font-bold'>55.55K</p>
                            </div>
                            <p className='text-center text-gray-300 text-base sm:text-lg lg:text-xl max-w-[30ch]'>Volume Traded</p>
                        </div>

                    </div>
            
                </div>

                <div className='py-8 mt-8 px-5 mb-10 sm:mb-20 '>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {collectionitems.map((item, index) => {
                            if(index < 12){
                                return(
                                    <ItemCard item = {item} key = {index}/>
                                )
                            }
                            else return null;
                        })}
                    </div>

                </div>

             

            </div>
            

        </div>        
    )
}

export default CollectionItem;